import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
    root: {
        '&.MuiDataGrid-root .MuiDataGrid-columnsContainer': {
            border: 'none',
        },
        '&.MuiDataGrid-root .MuiDataGrid-cell:focus-within': {
            outline: 'none',
        },
        '&.MuiDataGrid-root .MuiDataGrid-columnHeader--moving': {
            backgroundColor: 'white',
        },
        '&>.MuiDataGrid-main': {
            '&>.MuiDataGrid-columnHeaders': {
                borderBottom: 'none',
            },
            '& div div div div >.MuiDataGrid-cell': {
                borderBottom: 'none'
            },
        },
        '&.MuiDataGrid-root .MuiDataGrid-iconButtonContainer .MuiIconButton-label': {
            display: 'none',
        }
    }
}));